import React, { useState } from 'react';
import { Box } from '@chakra-ui/react';
import AdminNavbar from 'components/Navbars/AdminNavbar';

export default function StatisticsHeader() {
  const [globalFilter, setGlobalFilter] = useState('');

  return (
    <Box>
      <AdminNavbar
        logoText={'SURELLE DASHBOARD'}
        initialValue={globalFilter ?? ''}
        onChange={e => setGlobalFilter(e)}
        debounce={500}
      />
    </Box>
  );
}
